import request from '@utils/request'

export function postIntoWarehouseList(data) {//渠道选项
    return request({
        url:'/service/mg/warehouse-management/into-warehouse-list',
        method:'post',
        data
    })
}

export function postWaitIntoWarehouseList(data) {
    return request({
        url: '/service/mg/warehouse-management/wait-into-warehouse-list',
        method: 'POST',
        data,
    })
}

export function postInserIntoWarehouse(data) {
    return request({
        url: '/service/mg/warehouse-management/inser-into-warehouse',
        method: 'POST',
        data,
    })
}


export function getRecommendDetail(data) {
    return request({
        url: '/service/mg/warehouse-management/recommend-detail',
        method: 'POST',
        data,
    })
}

/*
* 接口名称推荐物流公司提交
* 请求类型post
* http://rap.essa.top:88/workspace/myWorkspace.do?projectId=211#7884
*/
export function submitRecommend(data) {
    return request({
        url: '/service/mg/warehouse-management/submit-recommend',
        method: 'POST',
        data,
    })
}
